import { Routes } from './'

export enum Environment {
  DYNDEV = 'DYNDEV',
  LOCALHOST = 'LOCALHOST',
  PPE = 'PPE',
  PROD = 'PROD',
  TST1 = 'TST1',
  TST3 = 'TST3',
}

export const EMPLOYMENT_TYPES = {
  na_dobu_neurcitou: '1',
  svobodne_povolani: '12',
  v_domacnosti: '13',
  dohoda_o_praci: '14',
  dohoda_o_cinnosti: '15',
  rentier: '16',
  duchodce_starobni: '17',
  duchodce_invalidni: '18',
  brigadnik: '19',
  na_dobu_urcitou: '2',
  materska_dovolena: '20',
  rodicovska_dovolena: '23',
  podnikatel: '3',
  student: '6',
  nezamestnany: '8',
}

export const SUPPORTED_EMPLOYMENT_TYPES = [
  EMPLOYMENT_TYPES.na_dobu_neurcitou,
  EMPLOYMENT_TYPES.na_dobu_urcitou,
  EMPLOYMENT_TYPES.podnikatel,
  EMPLOYMENT_TYPES.rentier,
  EMPLOYMENT_TYPES.duchodce_starobni,
  EMPLOYMENT_TYPES.duchodce_invalidni,
]

export enum SecondDocumentType {
  PASSPORT = 'PASSPORT',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
}

export enum IdentityStatus {
  LINK_GENERATED = 'LINK_GENERATED',
  LINK_OPENED = 'LINK_OPENED',
  UPLOAD_FINISHED = 'UPLOAD_FINISHED',
  CANCELED = 'CANCELED',
}

export enum ClientChecksStep {
  DOCUMENTS_CIF_STATUS = 'DOCUMENTS_CIF_STATUS',
  DOCUMENTS_IDENTITY_CHECK = 'DOCUMENTS_IDENTITY_CHECK',
  DOCUMENTS_INCOME_CHECK = 'DOCUMENTS_INCOME_CHECK',
  DOCUMENTS_LIST_OF_REQUIREMENTS = 'DOCUMENTS_LIST_OF_REQUIREMENTS',
  DOCUMENTS_POP_STATUS = 'DOCUMENTS_POP_STATUS',
  DOCUMENTS_PRECONTRACT_STATUS = 'DOCUMENTS_PRECONTRACT_STATUS',
  FINALIZATION_PAYMENT_CHECK = 'FINALIZATION_PAYMENT_CHECK',
  FINALIZATION_SIGNING = 'FINALIZATION_SIGNING',
  FINALIZATION_VICTORY = 'FINALIZATION_VICTORY',
}

export const ClientChecksRoutes = {
  [ClientChecksStep.DOCUMENTS_INCOME_CHECK]: Routes.POP_UPLOAD,
  [ClientChecksStep.DOCUMENTS_IDENTITY_CHECK]: Routes.IDENTITY,
  [ClientChecksStep.FINALIZATION_SIGNING]: Routes.PRINT_PRE_CONTRACT,
  [ClientChecksStep.FINALIZATION_PAYMENT_CHECK]: Routes.PENNY_PAYMENT,
  [ClientChecksStep.FINALIZATION_VICTORY]: Routes.FINAL,

  [ClientChecksStep.DOCUMENTS_PRECONTRACT_STATUS]: Routes.PRINT_PRE_CONTRACT,
  [ClientChecksStep.DOCUMENTS_CIF_STATUS]: Routes.CREATE_CIF,
  [ClientChecksStep.DOCUMENTS_POP_STATUS]: Routes.POST_PROCESSING,
}

export enum ContractSignStatus {
  OK = 'OK',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum PreContractStatus {
  IN_APPROVAL = 'IN_APPROVAL',
  NOK = 'NOK',
  OK = 'OK',
  RETRY = 'RETRY',
}

export enum SigningType {
  Contract = 'CONTRACT',
  PreContract = 'PRE_CONTRACT',
  Scoring = 'SCORING',
}

export enum SmsVerifyError {
  Ko = 'KO',
  Locked = 'LOCKED',
  TimedOut = 'TIMED_OUT',
}

export enum SmsVerifyResponse {
  Ko = 'KO',
  Locked = 'LOCKED',
  TimedOut = 'TIMED_OUT',
  Ok = 'OK',
  Nok = 'NOK',
}

export enum ScoringOk {
  Exact = 'OK',
  More = 'OK_MORE',
  Less = 'OK_LESS',
}

export enum Insurance {
  Yes = 'YES',
  No = 'NO',
  NotAvailable = 'NOT_AVAILABLE',
}

export enum PepOptions {
  Yes = 'YES',
  No = 'NO',
}

export enum AvailabilityStatus {
  Ok = 'OK',
  OngoingOutage = 'ONGOING_OUTAGE',
  PlannedOutage = 'PLANNED_OUTAGE',
}
